import React, { Component } from 'react'
import { Pagination } from 'antd';

class Common_Pagination extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {
        return (
            <>
                <div className="pagination-wrapper content-wrapper">
                    <Pagination
                        total={this.props.total}
                        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                        defaultPageSize={this.props.defaultPageSize}
                        defaultCurrent={this.props.defaultCurrent}
                    />
                </div>
            </>
        )
    }
}

export default Common_Pagination
